import {Component, Input, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NgForOf, NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {FileApiService} from "../../../../services/api/file-api.service";
import {PlanningRegionApiService} from "../../../../services/api/planning-region-api.service";
import {ToastService} from "../../../../services/toaster.service";
import {BaseComponent} from "../../../base/base.component";
import {Cinema} from "../../../../models/cinema.model";


@Component({
  selector: 'app-planning-region-exports-modal',
  templateUrl: './planning-region-exports-modal.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    TranslateModule,
    FormsModule
  ],
  styleUrls: ['./planning-region-exports-modal.component.scss']
})
export class PlanningRegionExportsModalComponent extends BaseComponent implements OnDestroy {
  @Input() cinemas: Cinema[] = [];
  @Input() title: string = '';
  exportForm: FormGroup;
  showEmailOptions = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private fileApiService: FileApiService,
    private planningRegionApiService: PlanningRegionApiService,
    private toastService: ToastService,
  ) {
    super();
    this.exportForm = this.fb.group({
      selectedCinema: ['all'],
      weeksBefore: [1, [Validators.required, Validators.min(0)]],
      weeksAfter: [5, [Validators.required, Validators.min(0)]],
      emailAdmin: [''],
      emailTech: [''],
      sendAdminEmails: [false],
      sendTechEmails: [false],
      format: ['pdf', Validators.required],
      type_export: ['etat_semaine', Validators.required]
    });

    const cinemaControl = this.exportForm.get('selectedCinema');

    if (cinemaControl) {
      const subscription = cinemaControl.valueChanges.subscribe(selectedCinema => {
        if (selectedCinema && selectedCinema !== 'all') {
          this.fetchContacts(selectedCinema);
          this.showEmailOptions = true;
        } else {
          this.showEmailOptions = false;
        }
      });
      this.subscriptions.add(subscription);
    }
    this.watchEmailChanges();
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  fetchContacts(idCinema: number): void {
    this.planningRegionApiService.fetchContacts(this.cookies, idCinema).subscribe(
      contacts => {
        const adminEmails = contacts.admin ? contacts.admin : '';
        const techEmails = contacts.tech ? contacts.tech: '';
        this.exportForm.patchValue({
          emailAdmin: adminEmails,
          emailTech: techEmails
        });
      },
      error => console.error('Error fetching contacts', error)
    );
  }

  closeModal(): void {
    this.activeModal.close();
  }

  export(): void {
    if (this.exportForm.valid) {
      const { selectedCinema, emailAdmin, emailTech, weeksBefore, weeksAfter, sendAdminEmails, sendTechEmails, format, type_export } = this.exportForm.value;

    const queryParams = {
      id_cinema: selectedCinema === null ? 'all' : selectedCinema.toString(),
      type: format,
      nb_before: weeksBefore,
      nb_after: weeksAfter,
      email_admin: sendAdminEmails ? emailAdmin : '',
      email_tech: sendTechEmails ? emailTech : '',
      send_admin_emails: sendAdminEmails,
      send_tech_emails: sendTechEmails,
      export: type_export,
      id_group: this.idRegion.toString()
    };

    if (format === 'pdf') {
      this.fileApiService.downloadPDF(this.cookies, 'planning_region/export_etat', queryParams);
    } else if (format === 'excel') {
      this.fileApiService.downloadExcel(this.cookies, 'planning_region/export_etat', queryParams);
    } else if (format === 'email') {
      this.planningRegionApiService.exportEtat(this.cookies, queryParams).subscribe(
        response => {
          this.toastService.showSuccess('toast.success');
          this.activeModal.close();
        },
        error => {
          this.toastService.showDanger('toast.error');
        }
      );
    }
    this.activeModal.close();
    }
  }

  watchEmailChanges(): void {
    const emailAdminControl = this.exportForm.get('emailAdmin');
    const sendAdminEmailsControl = this.exportForm.get('sendAdminEmails');
    const emailTechControl = this.exportForm.get('emailTech');
    const sendTechEmailsControl = this.exportForm.get('sendTechEmails');

    if (emailAdminControl) {
      this.subscriptions.add(emailAdminControl.valueChanges.subscribe(value => {
        sendAdminEmailsControl?.setValue(value.trim() !== '');
      }));
    }

    if (emailTechControl) {
      this.subscriptions.add(emailTechControl.valueChanges.subscribe(value => {
        sendTechEmailsControl?.setValue(value.trim() !== '');
      }));
    }
  }
}
